import styles from "./PoochBeach.module.css";

const PoochBeach: React.FC = () => {
  const poochBeachImage =
    "https://thehideawayretreat-storage-images234800-staging.s3.amazonaws.com/dsdvd.jpg";
  const poochBeachAltImageInfo =
    "Dog owner playing with her three dogs at our 371 ft dog beach in Navarre Florida at dusk at The Hideaway Retreat’s Pooch Beach";

  return (
    <div className={styles.poochBeachContainer}>
      <div className={styles.textSection}>
        <div className={styles.textContainer}>
          <div className={styles.rightTitle}>Pooch Beach</div>
          <div className={styles.rightText}>
            Enjoy unforgettable beach days with your fur baby on our 371 ft
            Pooch Beach and see why we’ve been named the most pet-friendly
            campground around.
          </div>
        </div>
      </div>
      <div className={styles.imageWrapper}>
        <img
          src={poochBeachImage}
          alt={poochBeachAltImageInfo}
          className={styles.image}
          loading="eager"
          draggable={false}
          decoding="async"
        />
      </div>
    </div>
  );
};

export default PoochBeach;
